declare let toastr: any;

export class Toastr {
    constructor() {
        toastr.options = {
            'closeButton': true,
            'debug': false,
            'progressBar': true,
            'preventDuplicates': false,
            'positionClass': 'toast-top-right',
            'onclick': null,
            'showDuration': '400',
            'hideDuration': '1000',
            'timeOut': '15000',
            'extendedTimeOut': '1000',
            'showEasing': 'swing',
            'hideEasing': 'linear',
            'showMethod': 'fadeIn',
            'hideMethod': 'fadeOut'
        }
    }
    Success(message?: string) {
        toastr.success(message || 'Successfully Published', 'SUCCESS');
    }
    Info(message: string) {
        toastr.info(message, 'INFO');
    }
    Error(message?: string) {
        toastr.error(message || 'An Error occured', 'ERROR');
    }
}